(function (angular) {
    'use strict';

    angular.module('broadcast')

        .config(['$stateProvider', function ($stateProvider) {


            $stateProvider

                .state('main.apiSpace.broadcastWizard', {
                    url: '/broadcast-wizard/:broadcastId',
                    templateUrl: 'components/toolkit/broadcast/templates/wizardView.html',
                    controller: 'BroadcastWizard',
                    controllerAs: 'vm',
                    resolve: {
                        initialisedWizard: ['$stateParams', "broadcastWizardService", function ($stateParams, broadcastWizardService) {
                            return broadcastWizardService.initialise($stateParams.pickedApiSpaceId, $stateParams.broadcastId, $stateParams.new, $stateParams.seed);
                        }],
                    },
                    params: {
                        new: null,
                    },
                    authenticate: true
                })
                .state({
                    name: 'main.apiSpace.existingBroadcasts',
                    url: '/broadcast/existing/:type',
                    templateUrl: 'components/toolkit/broadcast/templates/existingBroadcasts.html',
                    controller: 'ExistingBroadcastCtrl',
                    resolve: {
                        broadcasts: ['$q', 'broadcastService', '$stateParams', function ($q, broadcastService, $stateParams) {
                            return broadcastService.getBroadcasts($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    },
                    authenticate: true
                })

        }]);

})(window.angular);
